import * as R from 'ramda'
import {
  lensSelectedData,
  selectedData,
  selectableData,
  subGroupsKey,
  subscriberCountKey,
  mainGroupListKey,
  domainListKey,
  recepientType,
  allGroupSubscriberCountKey,
  everyoneSubGroupKey,
  everyoneCount,
} from 'libs/PagingLens'
import { isEmptyOrNil } from 'libs/empty'
import * as Utils from './StateCalUtils'
export const RECIPIENT_TYPE_EVERY_ONE = 'TYPE_EVERY_ONE'
export const RECIPIENT_TYPE_GROUPS = 'TYPE_GROUPS'
export const RECIPIENT_TYPE_NO_SUBSCRIBER = 'TYPE_NO_SUBSCRIBER'

// State Path
export const reduceGroupListToObject = (filterValidGroup) => (acc, x) => {
  if (R.isNil(filterValidGroup) || filterValidGroup(x))
    return { ...acc, [x.id]: x }
  else return acc
}

export const getAllSubGroup = (groupList) => {
  return R.flatten(groupList.map((group) => R.prop(subGroupsKey, group)))
}
const reduceInitialGroupIds = (subGroupObjectMap) => {
  const appendById = (acc, id) => {
    const existSubGroup = R.prop(id, subGroupObjectMap)
    if (R.anyPass([R.isEmpty, R.isNil])(existSubGroup)) return acc
    else
      return {
        ...acc,
        [id]: R.prop(id, subGroupObjectMap),
      }
  }
  return R.reduce(appendById, {})
}

export const createInitialStateFromDomain = R.curry(
  (filterOutSubGroup, oldState, domainData) => {
    const groups = R.prop(domainListKey)(domainData)
    const allSubGroups = getAllSubGroup(groups)
    const subGroupObjectMap = R.reduce(
      reduceGroupListToObject(filterOutSubGroup),
      {},
      allSubGroups,
    )

    const initalSelectedData = R.compose(
      reduceInitialGroupIds(subGroupObjectMap),
      R.propOr([], selectedData),
    )(oldState)
    return {
      ...oldState,
      [selectedData]: initalSelectedData,
      [selectableData]: subGroupObjectMap,
      [mainGroupListKey]: groups,
      ...R.pick([
        everyoneCount,
        subscriberCountKey,
        allGroupSubscriberCountKey,
        everyoneSubGroupKey,
      ])(domainData),
    }
  },
)
export const isSelectAll = (state) => {
  if (
    R.anyPass([
      isEmptyOrNil,
      R.compose(isEmptyOrNil, R.prop(selectableData)),
      R.compose(isEmptyOrNil, R.prop(selectedData)),
    ])(state)
  )
    return false
  else {
    const getLength = (propId) => R.compose(R.length, R.values, R.prop(propId))
    return getLength(selectableData)(state) === getLength(selectedData)(state)
  }
}
export const isUnSelectAll = (state) => {
  if (
    R.anyPass([isEmptyOrNil, R.compose(isEmptyOrNil, R.prop(selectableData))])(
      state,
    )
  )
    return undefined
  else
    return R.compose(
      R.anyPass([R.isNil, R.isEmpty]),
      R.prop(selectedData),
    )(state)
}

export const checkAllGroups = (state) =>
  R.set(lensSelectedData, R.prop(selectableData, state), state)
export const uncheckAllGroup = (state) => R.set(lensSelectedData, {}, state)

const updateCheckedGroups = (state) => (newCheckedGroups) => {
  return R.set(lensSelectedData, newCheckedGroups, state)
}
export const checkGroup = (state, subGroup) => {
  return R.compose(
    updateCheckedGroups(state),
    (checkdGroups) => ({ ...checkdGroups, [subGroup.id]: subGroup }),
    R.view(lensSelectedData),
  )(state)
}

export const unCheckGroup = (state, subGroup) => {
  return R.compose(
    updateCheckedGroups(state),
    R.omit([subGroup.id]),
    R.view(lensSelectedData),
  )(state)
}

export const getType = (state) => {
  const selectType = R.prop(recepientType)(state)
  if (isEmptyOrNil(state) || isEmptyOrNil(selectType)) return undefined

  if (!hasAnySubscriber(state)) return RECIPIENT_TYPE_NO_SUBSCRIBER
  if (R.equals(selectType, RECIPIENT_TYPE_EVERY_ONE))
    return RECIPIENT_TYPE_EVERY_ONE
  if (R.equals(selectType, RECIPIENT_TYPE_GROUPS)) return RECIPIENT_TYPE_GROUPS
  else {
    return undefined
  }
}

export const getSelectedSubGroup = R.compose(R.values, R.prop(selectedData))

export const getSelectedSubGroupIds = R.compose(
  R.ifElse(
    R.is(Array),
    R.values, // come from initial, TODO => the selectedData should alway be Array of id
    R.keys,
  ),
  R.prop(selectedData),
)

export const isMainGroupChecked = (state) => (subGroupIds) => {
  if (R.isEmpty(subGroupIds)) return false
  else
    return R.all((subGroupId) =>
      R.includes(subGroupId.toString(), getSelectedSubGroupIds(state)),
    )(subGroupIds)
}

export const checkMainGroup = (state, mainGroup, filter) => {
  const subGroupList = R.compose(
    R.reduce((acc, x) => ({ ...acc, [x.id]: x }), {}),
    R.filter(filter),
    R.values,
    R.prop(subGroupsKey),
  )(mainGroup)

  return R.compose(
    updateCheckedGroups(state),
    (checkdGroups) => ({ ...checkdGroups, ...subGroupList }),
    R.view(lensSelectedData),
  )(state)
}

export const uncheckMainGroup = (state, mainGroup) => {
  const subGroupIds = R.compose(
    R.map((subGroup) => subGroup.id),
    R.prop(subGroupsKey),
  )(mainGroup)
  return R.compose(
    updateCheckedGroups(state),
    R.omit(subGroupIds),
    R.view(lensSelectedData),
  )(state)
}

export const getSubGroupList = (mainGroup, filterValidGroup) => {
  const accumulate = reduceGroupListToObject(filterValidGroup)
  return R.compose(
    (subGroup) => R.reduce(accumulate, {}, subGroup),
    R.prop(subGroupsKey),
  )(mainGroup)
}

export const isValidSubGroup = Utils.isValidSubscriberCount(subscriberCountKey)
export const isValidMainGroup = R.compose(
  R.not,
  R.isEmpty,
  R.filter(isValidSubGroup),
  R.values,
  R.prop(subGroupsKey),
)

export const getAllSubgroupIds = (isKeep) =>
  R.compose(
    R.reduce((acc, subGroup) => {
      if (isKeep(subGroup)) return [...acc, R.prop('id', subGroup)]
      else return acc
    }, []),
    R.prop(subGroupsKey),
  )

export const hasAnySubscriber = R.compose(
  Utils.hasCountMoreThanZero,
  R.prop(subscriberCountKey),
)

export const hasAnySubscriberInGroups = R.compose(
  Utils.hasCountMoreThanZero,
  R.prop(allGroupSubscriberCountKey),
)
